export const TYPE_CLICK = {
  elementType: 'chat:button:click',
  screenName: 'credenciamento:chatbot'
};
